import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const programSubcategories = `${REACT_APP_API_PREFIX}/${service}/programSubcategories`;

export function getProgramSubcategories(filters) {
  const url = `${programSubcategories}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getProgramSubcategoryById(id) {
  const url = `${programSubcategories}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateProgramSubcategory(id, body) {
  const url = `${programSubcategories}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteProgramSubcategory(id) {
  const url = `${programSubcategories}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createProgramSubcategory(body) {
  const url = `${programSubcategories}`;
  return {
    method: POST,
    url,
    body,
  };
}
